module.exports = __webpack_public_path__ + "img/clock.a11504a4.svg";